import React from 'react';
import { FormGroup, FormControl, Form } from 'react-bootstrap';

/**
 * Custom DatePicker component with calendar icon on the left side.
 * 
 * Props:
 * - label: String - Label text for the date picker
 * - value: String - Current date value in YYYY-MM-DD format
 * - onChange: Function - Callback when date changes, receives the date value string
 * - controlId: String - Unique control ID for the form group (optional)
 * - style: Object - Additional styles for the FormGroup (optional)
 * - inputStyle: Object - Additional styles for the input (optional)
 * - fullWidth: Boolean - Whether to use full width (default: true)
 */
class CustomDatePicker extends React.Component {
    constructor(props) {
        super(props);
        this.dateInputRef = null;
    }

    handleIconClick = () => {
        if (this.dateInputRef && this.dateInputRef.showPicker) {
            this.dateInputRef.showPicker();
        }
    };

    render() {
        const {
            label,
            value,
            onChange,
            controlId = 'customDatePicker',
            style = {},
            inputStyle = {},
            fullWidth = true
        } = this.props;

        const containerStyle = fullWidth
            ? { display: 'block', width: '100%', ...style }
            : { display: 'inline-block', ...style };

        const wrapperStyle = fullWidth
            ? { position: 'relative', display: 'block', width: '100%' }
            : { position: 'relative', display: 'inline-block' };

        const dateInputStyle = fullWidth
            ? { paddingLeft: '35px', width: '100%', ...inputStyle }
            : { paddingLeft: '35px', ...inputStyle };

        return (
            <FormGroup controlId={controlId} style={containerStyle}>
                {/* CSS to hide native calendar picker indicator */}
                <style>{`
                    .custom-date-picker-input::-webkit-calendar-picker-indicator {
                        display: none;
                        -webkit-appearance: none;
                    }
                    .custom-date-picker-input::-webkit-inner-spin-button {
                        display: none;
                    }
                `}</style>

                {label && <Form.Label>{label}</Form.Label>}

                <div 
                    style={{...wrapperStyle, cursor: 'pointer'}}
                    onClick={(e) => {
                        // Only trigger if clicking on the wrapper itself, not the input
                        if (e.target === e.currentTarget || e.target.tagName === 'SPAN') {
                            this.handleIconClick();
                        }
                    }}
                >
                    <span
                        style={{
                            position: 'absolute',
                            left: '8px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            zIndex: 1,
                            pointerEvents: 'auto'
                        }}
                        onClick={this.handleIconClick}
                    >📅</span>
                    <FormControl
                        type="date"
                        className="custom-date-picker-input"
                        ref={(ref) => this.dateInputRef = ref}
                        value={value || ''}
                        style={{...dateInputStyle, cursor: 'pointer'}}
                        onChange={(e) => onChange && onChange(e.target.value)}
                        onClick={this.handleIconClick}
                    />
                </div>
            </FormGroup>
        );
    }
}

export default CustomDatePicker;
